import type { LocaleType } from "lib/apollo/types"
import { siteUrl } from "utils/getSiteUrl"
import type { BlackBanner, ImageBanner } from "./Header.types"

export const parseBlackBanner = (
  entry: Record<string, any>
): BlackBanner | undefined => {
  const contentType = entry?.type
  const showBanner = entry?.showBanner
  const contentArr = entry?.content?.content
  if (!contentArr?.length) return undefined
  const bannerContentArr = contentArr[0].content
  if (!bannerContentArr?.length) return undefined
  return { title: bannerContentArr[0]?.value, type: contentType, showBanner }
}

export const getBanner = (bannerFields: any): ImageBanner | undefined => {
  return bannerFields
    ? {
        title: bannerFields?.text,
        linkTitle: bannerFields?.linkText,
        linkUrl: bannerFields?.linkUrl,
        position: bannerFields?.bannerPosition ? "top" : "bottom",
        image:
          bannerFields?.image?.fields?.bynderData[0].thumbnails["OTF BETA"],
      }
    : undefined
}

export const getUrl = (locale: LocaleType, url: string): string => {
  if (url.startsWith("http")) return url
  let localePath = ""
  if (locale === "en-US" && !url.startsWith("/us/")) {
    localePath = "/us"
  }

  return `${siteUrl}${localePath}${url}`
}
